import { useEffect, useRef } from 'react';
import { displayApiCall } from './displayApi';
import { getOrCreateDisplayDeviceId } from './displayConfig';
import { getEmbedContext } from '../utils/embedContext';

const HEARTBEAT_MS = 30000;

/** Presence heartbeats for no-login display sessions (device id only, no email). */
export const useDisplayHeartbeat = (enabled) => {
	const started = useRef(false);

	useEffect(() => {
		if (!enabled) return undefined;

		const deviceId = getOrCreateDisplayDeviceId();
		const embed = getEmbedContext();
		const payload = {
			kind: 'display',
			deviceId,
			...(embed.inIframe
				? {
						inIframe: true,
						parentOrigin: embed.parentOrigin,
						referrer: embed.referrer,
					}
				: {}),
		};

		const sendHeartbeat = async () => {
			try {
				await displayApiCall('heartbeat', payload, 'POST');
			} catch (err) {
				console.error('Display heartbeat failed', err);
			}
		};

		if (!started.current) {
			started.current = true;
			sendHeartbeat();
		}

		const intervalId = setInterval(sendHeartbeat, HEARTBEAT_MS);
		const onVisibility = () => {
			if (document.visibilityState === 'visible') {
				sendHeartbeat();
			}
		};
		document.addEventListener('visibilitychange', onVisibility);

		return () => {
			clearInterval(intervalId);
			document.removeEventListener('visibilitychange', onVisibility);
		};
	}, [enabled]);
};
